/**
 * How a customer relates to one of the sales zone's options.
 * `inherit` is the default and leaves the zone's setting untouched, `yes` and `no`
 * replace it for this customer.
 */
export var CustomerOverride;
(function (CustomerOverride) {
    CustomerOverride["inherit"] = "inherit";
    CustomerOverride["yes"] = "yes";
    CustomerOverride["no"] = "no";
})(CustomerOverride || (CustomerOverride = {}));
export const CUSTOMER_OVERRIDES = [
    CustomerOverride.inherit,
    CustomerOverride.yes,
    CustomerOverride.no,
];
/**
 * Anything that is not an explicit yes/no counts as inherit. That also covers customers
 * written before an override existed and any value we don't recognise.
 */
export function asCustomerOverride(value) {
    if (value === CustomerOverride.yes || value === CustomerOverride.no) {
        return value;
    }
    return CustomerOverride.inherit;
}
/**
 * The value that really applies: the customer's, if it has an opinion, the zone's otherwise.
 */
export function resolveCustomerOverride(zoneValue, customerValue) {
    let override = asCustomerOverride(customerValue);
    if (override == CustomerOverride.yes) {
        return true;
    }
    if (override == CustomerOverride.no) {
        return false;
    }
    return Boolean(zoneValue);
}
